import React from 'react';
import { brand } from '../data/brand';
export function FounderSection() {
  return <section id="founder" aria-labelledby="founder-heading" className="w-full border-t border-line bg-white py-24 md:py-36" data-id="element-106" data-mp="2w9zs9zzwswpu">
      <div className="mx-auto grid max-w-editorial items-center gap-12 px-6 md:px-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1fr)] lg:gap-24 lg:px-20" data-id="element-107" data-mp="3ab2dybmzs508">
        <figure className="relative" data-id="element-108" data-mp="3k7f5b2v2e6rt">
          <div className="border border-line p-3" data-id="element-109" data-mp="3k6dtgw685g91">
            <img src={brand.founderPortrait} alt="Yubri, founder of ELORA Fine Jewelry, wearing 18K gold pieces" className="aspect-[3/4] w-full object-cover object-[50%_22%]" data-id="element-110" data-mp="3f8vjr3kduwzz" />
          </div>
          <figcaption className="mt-4 font-sans text-[11px] uppercase tracking-luxe text-maroon-mute" data-id="element-111" data-mp="3ozqaak4nwir8">
            Yubri · Founder
          </figcaption>
        </figure>

        <div data-id="element-112" data-mp="1uh1ulz2cvsw">
          <span className="block h-px w-14 bg-gold" aria-hidden="true" data-id="element-113" data-mp="1uqtedzrbb0p" />
          <h2 id="founder-heading" className="mt-6 font-serif text-[1.9rem] leading-tight text-maroon md:text-[2.6rem]" data-id="element-114" data-mp="295tg1kvkn3rp">
            The Essence of ELORA: A Vision of Brilliance
          </h2>
          <div className="mt-7 max-w-xl space-y-6 font-sans text-[15px] font-light leading-[1.85] text-maroon-soft" data-id="element-115" data-mp="2j2oczzc74w3v">
            <p data-id="element-116" data-mp="2o4597hjqjue4">
              Born into a family of entrepreneurs, Yubri has always been a woman
              of business with a vision for the future. Her love for fine
              jewelry, together with a long-standing friendship with people in
              the gold industry, inspired a new dream: to bring unique and
              elegant 18K Gold and Italian Gold pieces to New York.
            </p>
            <p data-id="element-117" data-mp="36saeitg1jnf1">
              But ELORA is more than jewelry. The name ELORA, “God is my light,”
              reflects the faith behind this journey and the belief that God has
              guided every step of this project.
            </p>
            <p data-id="element-118" data-mp="1gogrcwl3o7zs">
              Each piece is carefully chosen for its beauty, elegance, and unique
              character — for women and men who are looking for something
              different, meaningful, and timeless.
            </p>
          </div>
          <p className="mt-9 border-l-2 border-gold pl-6 font-serif text-lg italic text-maroon" data-id="element-119" data-mp="1pilh1cohzddq">
            “ELORA — God is my light.”
          </p>
        </div>
      </div>
    </section>;
}